export default __webpack_public_path__ + "static/media/2-6-3.b5b0f613.jpg";